angular.module('app').directive('permissao', function() {
	return {
        restrict: 'A',
        scope:{
            ngModel: '=?'
        },
        controller: function($scope, $http) {
            $scope.getPermissao = function(chave, valor, element){
                $http({
                    'url': 'admin/usuarios/check-permissao?chave='+chave+'&valor='+valor+'&t='+moment(),
                }).then(function(res){
                    $scope.ngModel = res.data[0];

                    element.removeAttr('checando-permissao');
                    if(!res.data[0]){
                        $scope.semPermissao(element);
                    }
                });
            };

            $scope.semPermissao = function(element){
                element.remove();
            };
        },
        link: function ($scope, $element, attrs) {
            $element.attr('checando-permissao', true);
            var chave = attrs['permissao'];
            var valor = attrs['valor'] ? attrs['valor'] : 'valor';

            $scope.getPermissao( chave, valor, $element );
        }
    };
})